export default __webpack_public_path__ + "/dist/images/image00021.0f9eff0760f733f3cfe29c811866d01b.jpg";